import { checkinApi } from '@/services/api/httpClient';

const actions = {
  async sendValidationToken({ getters }) {
    const mdmPatientId = getters.mdmPatientId;
    const brand = getters.selectedBrand.whatsappName;
    const contactId = getters.contactSelectedId;

    try {
      await checkinApi().post('/patient/notification', {
        mdmPatientId,
        contactId,
        brand,
      });
      return { status: 200 };
    } catch {
      throw new Error('sendValidationToken ERROR');
    }
  },

  async mdmConfirmationToken({ getters, commit }, token) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const mdmId = getters.getMdmState.data.id;
    commit('SET_MESSAGE', '');

    return await checkinApi()
      .post(`/admission/confirm-token`, {
        token,
        admissionId,
        mdmId,
      })
      .then(({ data }) => {
        const isTokenValid = data.status === 200;
        const jwt = data.statusText;
        sessionStorage.setItem('user', jwt);
        return isTokenValid;
      })
      .catch((err) => {
        commit('SET_MESSAGE', err.response.data.message);
        return false;
      });
  },
};

export default actions;
